<template>
  <v-dialog
    v-if="(typeof permissions.catalog.additional !== 'undefined' && permissions.catalog.additional)"
    v-model="dialog"
    :fullscreen="is_mobile"
    :scrollable="false"
    overlay-opacity="50"
    max-width="70%"
    content-class="default-dialog"
  >
    <template v-slot:activator="{}">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            medium
            @click.stop="dialog = true"
            :disabled="get_interface.loading"
          >
            <v-icon medium>{{ lang.additional.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.additional.title }}</span>
      </v-tooltip>
    </template>
    <v-card class="default-dialog-card list-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon>{{ lang.additional.icon }}</v-icon>
          {{ `${lang.additional.title_} ${lang[catalog].title}` }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-container
          class="overflow-y-auto dialog-scrollbar"
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
        >
          <div fluid class="catalog-page">
            <v-row>
              <Search name="additional" />
            </v-row>
            <v-row>
              <v-col cols="12" class="list-col">
                <List :catalog="catalog" />
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Search from '@/templates/global/Search'
import List from './templates/List'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Search, List },
  mixins: [ appdata, utils ],
  props: {
    catalog: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    dialog () {
      this.$store.dispatch('setGlobalSearch', { additional: '' })
    }
  }
}
</script>

<style src="../styles/index.scss" lang="scss"></style>
